






















import Vue from 'vue';
import {Component, Model, Prop} from 'vue-property-decorator';
import Overlay from "@/views/Overlay.vue";

@Component({
  components: {Overlay}
})
export default class PopUp extends Vue {
@Model('change',{type:Boolean,required:true}) readonly show!:boolean
  @Prop({default:300}) readonly duration!:number
  @Prop(String) readonly height?:string
}
